// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__gtRZV","note":"style_note__VruMk","add-comment":"style_add-comment__NNs77","modal":"style_modal__Zazjt","icons":"style_icons__D1MBJ"};